import {useRouter} from 'next/router'
import {useCallback, useMemo} from 'react'

import {CONNECT_SCHEME, ConnectType, getConnectPagePath} from '@mydata/utils/connect'

import baseOrigin from '$utils/baseOrigin'
import buildUrl from '$utils/buildUrl'

interface UseConnectUrlProps {
    scheme?: (typeof CONNECT_SCHEME)[keyof typeof CONNECT_SCHEME] | string
    orgCodeList?: string[]
    rurl?: string
    curl?: string
}

export const useNewConnectionUrl = ({scheme, rurl, curl, orgCodeList}: UseConnectUrlProps = {}) => {
    const router = useRouter()
    const connectUrl = useMemo(() => {
        const href = buildUrl({
            pathname: router.pathname,
            query: router.query,
            withBasePath: true,
        })
        return `${baseOrigin}${getConnectPagePath({
            type: ConnectType.NewConnection,
            scheme: scheme || CONNECT_SCHEME.DEFAULT,
            rurl: rurl || href,
            curl: curl || href,
            ...(orgCodeList && {orgCodeList}),
        })}`
    }, [scheme, rurl, curl, router, orgCodeList])

    const enterConnectUrl = useCallback(() => {
        window.open(connectUrl)
    }, [connectUrl])

    return {connectUrl, enterConnectUrl}
}

export const useNewAssetUrl = ({scheme, rurl, curl}: UseConnectUrlProps = {}) => {
    const router = useRouter()
    const connectUrl = useMemo(() => {
        const href = buildUrl({
            pathname: router.pathname,
            query: router.query,
            withBasePath: true,
        })
        return `${baseOrigin}${getConnectPagePath({
            type: ConnectType.NewAsset,
            scheme: scheme || CONNECT_SCHEME.EXPIRE,
            rurl: rurl || href,
            curl: curl || href,
        })}`
    }, [scheme, rurl, curl, router])

    const enterConnectUrl = useCallback(() => {
        window.open(connectUrl)
    }, [connectUrl])

    return {connectUrl, enterConnectUrl}
}

export const useReconnectAllSkipFirstUrl = ({scheme, rurl, curl}: UseConnectUrlProps = {}) => {
    const router = useRouter()
    const connectUrl = useMemo(() => {
        const href = buildUrl({
            pathname: router.pathname,
            query: router.query,
            withBasePath: true,
        })
        return `${baseOrigin}${getConnectPagePath({
            type: ConnectType.ReconnectAllSkipFirst,
            scheme: scheme || CONNECT_SCHEME.EXPIRE,
            rurl: rurl || href,
            curl: curl || href,
        })}`
    }, [scheme, rurl, curl, router])

    const enterConnectUrl = useCallback(() => {
        window.open(connectUrl)
    }, [connectUrl])

    return {connectUrl, enterConnectUrl}
}
